// latest: zhangmyh 2017-6-21 4:23 PM
/* global $ ko */
import './index.less'

ko.components.register('form-editor', {
  viewModel: require('./form-editor/index').default,
  template: require('./form-editor/index.html')
})

ko.components.register('form-span', {
  viewModel: require('./form-span/index').default,
  template: require('./form-span/index.html')
})

ko.components.register('form-refer', {
  viewModel: require('./form-refer/index').default,
  template: require('./form-refer/index.html')
})

ko.components.register('form-select', {
  viewModel: require('./form-select/index').default,
  template: require('./form-select/index.html')
})

ko.components.register('form-textarea', {
  viewModel: require('./form-textarea/index').default,
  template: require('./form-textarea/index.html')
})

ko.components.register('form-date', {
  viewModel: require('./form-date/index').default,
  template: require('./form-date/index.html')
})

ko.components.register('view-span', {
  viewModel: require('./view-span/index').default,
  template: require('./view-span/index.html')
})

// 显示/隐藏tip
$(document).on('click', function (e) {
  let ele = $(e.target)
  if (ele.hasClass('bie-content')) {
    let tmp = ele.parent().next()
    if (tmp.length <= 0 || !tmp.hasClass('bie-tip')) {
      $('.bie-tip-visible').removeClass('bie-tip-visible')
    }
  } else if (ele.hasClass('bie-tip-list')) {
  } else if (ele.hasClass('bie-tip-icon')) {
    let list = ele.next()
    if (list.hasClass('bie-tip-visible')) {
      list.removeClass('bie-tip-visible')
    } else {
      list.addClass('bie-tip-visible')
    }
  } else {
    $('.bie-tip-visible').removeClass('bie-tip-visible')
  }
})



// WEBPACK FOOTER //
// ./src/components/ag-form/index.js